import { theme, UI_TYPOGRAPHY_ROOT_CLASS } from '@prophecy/theme/theme';
import { getInterFontWeightCSS } from '@prophecy/theme/utils';
import { createGlobalStyle, css } from 'styled-components';
import { tokens as tableTokens } from '../Table/tokens';
export const GlobalStyle = createGlobalStyle `
  * {
    box-sizing: border-box;
    font-feature-settings: 'salt' on;
  }
  
  pre {
    margin: 0;
  }

  input::placeholder, textarea::placeholder {
    color: ${theme.colors.gray500};
    opacity: .5;
  }
`;
export const globalScrollBarCss = css `
  ::-moz-scrollbar-thumb {
    scrollbar-color: ${theme.colors.gray300} !important;
    scrollbar-width: thin !important;
  }
  ::-webkit-scrollbar {
    width: ${theme.scrollbarWidth};
  }
  ::-webkit-scrollbar-track,
  ::-webkit-scrollbar:horizontal {
    background: ${theme.colors.white};
  }
  ::-webkit-scrollbar:horizontal {
    height: ${theme.scrollbarWidth};
  }
  ::-webkit-scrollbar-thumb:horizontal,
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray300};
    border-radius: ${theme.radius.full};
    &:hover {
      background: ${theme.colors.gray400};
      scrollbar-color: ${theme.colors.gray400} !important;
    }
  }
`;
export const TypographyGlobalStyle = createGlobalStyle `
  html,
  body {
    color: ${theme.colors.gray900};
    font-family: ${theme.fontFamily.text};
    font-size: ${theme.text.sm.fontSize};
    ${getInterFontWeightCSS(theme.fontWeight.normal)};
    line-height: ${theme.text.sm.lineHeight};
    margin: 0;
    padding: 0;
    height: 100vh;
    width: 100%;
  }
  ${globalScrollBarCss}
  [hidden] {
      display: none!important;
  }
  
  label{
    font-size: inherit;
    line-height: inherit;
  }
  
  blockquote, dd, dl, figure, h1, h2, h3, h4, h5, h6, hr, p, pre{
    margin: 0;
  }
  
  input::placeholder, textarea::placeholder {
    color: ${theme.colors.gray500};
    opacity: .5;
  }

  *, :after, :before {
      box-sizing: border-box;
  }
  a {
    background-color: transparent;
    cursor: pointer;
    outline: none;
    color: ${theme.colors.brand600};
    text-decoration: none;
  }
  img[src='""'] {
    display: none;
  }
  img[src='--'] {
    display: none;
  }
  &&.${UI_TYPOGRAPHY_ROOT_CLASS} {
      font-family: ${theme.fontFamily.text};
      color: ${theme.colors.gray900};

      h1, h2, h3, h4, h5, h6 {
        color: ${theme.colors.gray700};
        line-height: 1.6;
        ${getInterFontWeightCSS(theme.fontWeight.semiBold)};
      }

      h1 {
        font-size: ${theme.text.xl.fontSize};
        margin-bottom: ${theme.spaces.x20};
      }

      h2 {
        font-size: ${theme.text.lg.fontSize};
        margin-bottom: ${theme.spaces.x16};
      }

      h3 {
        font-size: ${theme.text.md.fontSize};
        margin-bottom: ${theme.spaces.x12};
      }

      p {
        margin-bottom: ${theme.spaces.x12};
        &:last-child {
          margin-bottom: 0;
        }
      }
      hr {
        margin: ${theme.spaces.x24} 0;
      }
      a {
        outline: none;
        text-decoration: none;
        color: ${theme.colors.brand600};
      }
      strong {
        ${getInterFontWeightCSS(theme.fontWeight.semiBold)};
      }
      em {
        background: ${theme.colors.warning500};
        padding: ${theme.spaces.x4};
        margin: 0 ${theme.spaces.x4};
      }

      blockquote {
        padding: 0 0 0 ${theme.spaces.x8};
        border-left: 4px solid ${theme.colors.gray300};
        margin-bottom: ${theme.spaces.x12};
        &:last-child {
          margin-bottom: 0;
        }
      }

      ul, ol {
        padding-left: ${theme.spaces.x16};
        margin: 0 0 ${theme.spaces.x12};
        &:last-child {
          margin-bottom: 0;
        }
      }
      ul li,
      ol li {
        margin: 0 0 0 ${theme.spaces.x12};
        padding: 0 0 0 ${theme.spaces.x2};
      }

      code {
        display: inline-block;
        font-size: 85%;
        letter-spacing: 0.01em;
        margin: ${theme.spaces.x2} 0px;
        padding: ${theme.spaces.x2} ${theme.spaces.x4};
        background: ${theme.colors.gray100};
        border-radius: ${theme.radius.x6};
      }

      pre {
        padding: ${theme.spaces.x8} ${theme.spaces.x12};
        white-space: pre-wrap;
        word-wrap: break-word;
        background: ${theme.colors.gray100};
        border: 1px solid ${theme.colors.gray200};
        border-radius: ${theme.radius.x6};
        code {
          display: inline;
          margin: 0;
          padding: 0;
          font-size: inherit;
          font-family: inherit;
          background: transparent;
          border: 0;
        }
      }

      table {
        border: 1px solid ${tableTokens.Table.borderColor};
        border-radius: ${tableTokens.Table.borderRadius};
        margin-bottom: ${theme.spaces.x12};
        border-spacing: 0;

        th {
          ${getInterFontWeightCSS(theme.fontWeight.semiBold)};
          background-color: ${tableTokens.Head.backgroundColor};

          &:first-child {
            border-top-left-radius: ${tableTokens.Table.borderRadius};
          }

          &:last-child {
            border-top-right-radius: ${tableTokens.Table.borderRadius};
          }
        }

        th, td {
          padding: 0 ${tableTokens.Cell.padding};
          text-align: left;
          border-bottom: 1px solid ${tableTokens.Table.borderColor};
          height: ${tableTokens.Row.height};
        }
        
        tr:last-child {
          td {
            border-bottom: none;
          }
        }

        tbody tr:hover {
          background-color: ${tableTokens.Row.hover.backgroundColor};
        }
      }
    }
`;
export const AvoidBrowserNavigationOnScroll = createGlobalStyle `
  html, body {
    overscroll-behavior: contain;
  }
`;
